import { render } from "./CreateProperty.vue?vue&type=template&id=3ceee561&scoped=true"
import script from "./CreateProperty.vue?vue&type=script&lang=js"
export * from "./CreateProperty.vue?vue&type=script&lang=js"

import "./CreateProperty.vue?vue&type=style&index=0&id=3ceee561&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ceee561"]])

export default __exports__